import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  updateDoc,
  doc,
  getDoc,
  increment,
} from "firebase/firestore";
import { db } from "../config";
import NavBar from "./NavBar";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Withdrawal() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(null);

  const fetchWithdrawals = async (next = false) => {
    setLoading(true);
    try {
      const withdrawRef = collection(db, "withdrawals");
      let q = query(withdrawRef, orderBy("createdAt", "desc"), limit(10));

      if (next && lastVisible) {
        q = query(
          withdrawRef,
          orderBy("createdAt", "desc"),
          startAfter(lastVisible),
          limit(10)
        );
      }

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setWithdrawals((prev) => (next ? [...prev, ...data] : data));
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    } catch (err) {
      console.error("Error fetching withdrawals:", err);
      toast.error("Failed to fetch withdrawals.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    if (withdrawals.find((w) => w.id === id).status === "approved") {
      toast.error("Cannot change status of an approved withdrawal.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setStatusUpdating(id);
    try {
      const withdrawRef = doc(db, "withdrawals", id);
      const withdrawalSnap = await getDoc(withdrawRef);
      const withdrawalData = withdrawalSnap.data();

      if (!withdrawalData) {
        console.error("Withdrawal not found.");
        toast.error("Withdrawal not found.", {
          position: "top-right",
          autoClose: 3000,
        });
        setStatusUpdating(null);
        return;
      }

      const { userId, amount, email, cryptoType, walletAddress, username, status: oldStatus } = withdrawalData;

      // Update the withdrawal status
      await updateDoc(withdrawRef, { status: newStatus });

      if (oldStatus !== "approved" && newStatus === "approved") {
        // Increment Totalwithdrawals for approved status
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, {
          Totalwithdrawals: increment(parseFloat(amount)),
        });
        console.log(`✅ Incremented Totalwithdrawals for user: ${userId}`);

        // Send success email
        await axios.post("https://renderbackend-mh2v.onrender.com/send-mail", {
          email: email,
          subject: "Withdrawal Successfully Processed",
          CompanyName: "GRANDFUNDED",
          htmlToSend: `
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #eee; padding: 20px; border-radius: 10px; background-color: #f9f9f9;">
              <div style="text-align: center; margin-bottom: 20px;">
                <img src="https://grandfunded.com/assets/images/logo.png" alt="GRANDFUNDED Logo" style="height: 60px;" />
                <h2 style="margin: 10px 0; color: #1a1a1a;">GRANDFUNDED</h2>
              </div>
              <h3 style="color: #333;">Congratulations!</h3>
              <p style="color: #555;">Your withdrawal has been successfully processed:</p>
              <table style="width: 100%; border-collapse: collapse; margin: 15px 0;">
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Method:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;">${cryptoType || "N/A"}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Amount:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><span style="color: #212529">$${parseFloat(amount).toFixed(2)}</span></td>
                </tr>
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Wallet Address:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;">${walletAddress || "N/A"}</td>
                </tr>
              </table>
              <p style="color: #555;">The amount has been sent to your ${cryptoType || "specified"} wallet.</p>
              <p style="margin-top: 20px; color: #555;">Thank you for choosing GRANDFUNDED!</p>
              <p style="color: #888;">– The GRANDFUNDED Team</p>
              <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;" />
              <p style="font-size: 12px; color: #aaa; text-align: center;">
                © ${new Date().getFullYear()} GRANDFUNDED. All rights reserved.
              </p>
            </div>
          `,
        });

        toast.success("Withdrawal approved successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      } else if (newStatus === "rejected") {
        // Add amount back to user's balance
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, {
          balance: increment(parseFloat(amount)),
        });
        console.log(`✅ Added ${amount} back to user balance: ${userId}`);

        // Send rejection email
        await axios.post("https://renderbackend-mh2v.onrender.com/send-mail", {
          email: email,
          subject: "Withdrawal Request Rejected",
          CompanyName: "GRANDFUNDED",
          htmlToSend: `
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #eee; padding: 20px; border-radius: 10px; background-color: #f9f9f9;">
              <div style="text-align: center; margin-bottom: 20px;">
                <img src="https://grandfunded.com/assets/images/logo.png" alt="GRANDFUNDED Logo" style="height: 60px;" />
                <h2 style="margin: 10px 0; color: #1a1a1a;">GRANDFUNDED</h2>
              </div>
              <h3 style="color: #333;">Dear ${username || "User"},</h3>
              <p style="color: #555;">Your withdrawal request has been rejected:</p>
              <table style="width: 100%; border-collapse: collapse; margin: 15px 0;">
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Method:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;">${cryptoType || "N/A"}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Amount:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><span style="color: #212529">$${parseFloat(amount).toFixed(2)}</span></td>
                </tr>
                <tr>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>Wallet Address:</strong></td>
                  <td style="padding: 8px; border-bottom: 1px solid #ddd;">${walletAddress || "N/A"}</td>
                </tr>
              </table>
              <p style="color: #555;">Reason: Your withdrawal request did not meet the required conditions.</p>
              <p style="color: #555;">The amount of $${parseFloat(amount).toFixed(2)} has been added back to your account balance.</p>
              <p style="margin-top: 20px; color: #555;">Please contact support if you have any questions.</p>
              <p style="color: #888;">– The GRANDFUNDED Team</p>
              <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;" />
              <p style="font-size: 12px; color: #aaa; text-align: center;">
                © ${new Date().getFullYear()} GRANDFUNDED. All rights reserved.
              </p>
            </div>
          `,
        });

        toast.success("Withdrawal rejected, amount added back to user balance.", {
          position: "top-right",
          autoClose: 3000,
        });
      }

      // Update UI
      setWithdrawals((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (err) {
      console.error("Failed to update withdrawal status or send email:", err);
      toast.error("Failed to update withdrawal status.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    setStatusUpdating(null);
  };

  // Helper function to format timestamp
  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    if (timestamp.seconds) {
      // Firestore Timestamp
      return new Date(timestamp.seconds * 1000).toLocaleString();
    }
    if (timestamp instanceof Date) {
      // JavaScript Date
      return timestamp.toLocaleString();
    }
    if (typeof timestamp === "string") {
      // ISO string or other string
      const parsedDate = new Date(timestamp);
      return isNaN(parsedDate) ? "N/A" : parsedDate.toLocaleString();
    }
    return "N/A";
  };

  return (
    <div className="container-fluid">
      {/* Top Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      {/* Custom Navigation Bar */}
      <NavBar />

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Withdrawals Table */}
      <div className="container mt-4">
        <h3 className="text-center mb-4">Withdrawals</h3>

        {loading && (
          <div className="text-center">
            <i className="fas fa-spinner fa-spin fa-2x"></i> Loading...
          </div>
        )}

        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Email</th>
                <th>Amount</th>
                <th>Crypto Type</th>
                <th>Wallet Address</th>
                <th>Status</th>
                <th>Change Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.map((w) => (
                <tr key={w.id}>
                  <td>{w.email || "N/A"}</td>
                  <td><span style={{ color: "#212529" }}>${parseFloat(w.amount || 0).toFixed(2)}</span></td>
                  <td>{w.cryptoType || "N/A"}</td>
                  <td>{w.walletAddress || "N/A"}</td>
                  <td>
                    <span
                      className={`badge bg-${
                        w.status === "pending"
                          ? "warning"
                          : w.status === "approved"
                          ? "success"
                          : "danger"
                      }`}
                    >
                      {w.status || "N/A"}
                    </span>
                  </td>
                  <td>
                    <select
                      className="form-select"
                      disabled={statusUpdating === w.id || w.status === "approved"}
                      value={w.status || "pending"}
                      onChange={(e) => handleStatusChange(w.id, e.target.value)}
                      aria-label={`Change status for withdrawal ${w.id}`}
                    >
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </td>
                  <td>{formatDate(w.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {lastVisible && (
          <div className="text-center mt-3">
            <button
              className="btn btn-secondary"
              onClick={() => fetchWithdrawals(true)}
              disabled={loading}
            >
              Load More
            </button>
          </div>
        )}
      </div>

      <style>
        {`
          .Toastify__toast--success {
            background-color: #d4edda;
            color: #155724;
          }
          .Toastify__toast--error {
            background-color: #f8d7da;
            color: #721c24;
          }
        `}
      </style>
    </div>
  );
}

export default Withdrawal;


// import React, { useEffect, useState } from "react";
// import {
//   collection,
//   getDocs,
//   query,
//   orderBy,
//   limit,
//   startAfter,
//   updateDoc,
//   doc,
//   getDoc,
//   increment,
// } from "firebase/firestore"; // Make sure 'increment' is imported
// import { db } from "../config"; // Adjust this path
// import NavBar from "./NavBar"; // Ensure this path is correct

// function Withdrawal() {
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [lastVisible, setLastVisible] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [statusUpdating, setStatusUpdating] = useState(null);

//   const fetchWithdrawals = async (next = false) => {
//     setLoading(true);
//     try {
//       const withdrawRef = collection(db, "withdrawals");
//       let q = query(withdrawRef, orderBy("createdAt", "desc"), limit(10));

//       if (next && lastVisible) {
//         q = query(
//           withdrawRef,
//           orderBy("createdAt", "desc"),
//           startAfter(lastVisible),
//           limit(10)
//         );
//       }

//       const snapshot = await getDocs(q);
//       const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setWithdrawals((prev) => (next ? [...prev, ...data] : data));
//       setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
//     } catch (err) {
//       console.error("Error fetching withdrawals:", err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchWithdrawals();
//   }, []);

// const handleStatusChange = async (id, newStatus) => {
//   setStatusUpdating(id);
//   try {
//     const withdrawRef = doc(db, "withdrawals", id);
//     const withdrawalSnap = await getDoc(withdrawRef);
//     const withdrawalData = withdrawalSnap.data();

//     if (!withdrawalData) {
//       console.error("Withdrawal not found.");
//       return;
//     }

//     const { userId, amount, status: oldStatus } = withdrawalData;

//     // Update the withdrawal status
//     await updateDoc(withdrawRef, { status: newStatus });

//     // Only increment if status changed from pending to approved
//     if (oldStatus !== "approved" && newStatus === "approved") {
//       const userRef = doc(db, "users", userId);
//       await updateDoc(userRef, {
//         Totalwithdrawals: increment(parseFloat(amount)),
//       });
//       console.log(`✅ Incremented Totalwithdrawals for user: ${userId}`);
//     }

//     // Update UI
//     setWithdrawals((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, status: newStatus } : item
//       )
//     );
//   } catch (err) {
//     console.error("Failed to update withdrawal status:", err);
//   }
//   setStatusUpdating(null);
// };

//   return (
//     <div className="container-fluid">
//       {/* Top Navbar */}
//       <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
//         <ul className="navbar-nav">
//           <li className="nav-item">
//             <a
//               className="nav-link"
//               data-widget="pushmenu"
//               href="#"
//               role="button"
//             >
//               <i className="fas fa-bars" />
//             </a>
//           </li>
//         </ul>
//       </nav>

//       {/* Custom Navigation Bar */}
//       <NavBar />

//       {/* Withdrawals Table */}
//       <div className="container mt-4">
//         <h3 className="text-center mb-4">Withdrawals</h3>

//         {loading && <div className="text-center">Loading...</div>}

//         <div className="table-responsive">
//           <table className="table table-bordered table-striped">
//             <thead className="table-dark">
//               <tr>
//                 <th>Email</th>
//                 <th>Amount</th>
//                 <th>Crypto Type</th>
//                 <th>Wallet Address</th>
//                 <th>Status</th>
//                 <th>Change Status</th>
//                 <th>Created At</th>
//               </tr>
//             </thead>
//             <tbody>
//               {withdrawals.map((w) => (
//                 <tr key={w.id}>
//                   <td>{w.email}</td>
//                   <td>${parseFloat(w.amount).toFixed(2)}</td>
//                   <td>{w.cryptoType}</td>
//                   <td>{w.walletAddress}</td>
//                   <td>
//                     <span
//                       className={`badge bg-${
//                         w.status === "pending"
//                           ? "warning"
//                           : w.status === "approved"
//                           ? "success"
//                           : "danger"
//                       }`}
//                     >
//                       {w.status}
//                     </span>
//                   </td>
//                   <td>
//                     <select
//                       className="form-select"
//                       disabled={statusUpdating === w.id}
//                       value={w.status}
//                       onChange={(e) =>
//                         handleStatusChange(w.id, e.target.value)
//                       }
//                     >
//                       <option value="pending">Pending</option>
//                       <option value="approved">Approved</option>
//                       <option value="rejected">Rejected</option>
//                     </select>
//                   </td>
//                   <td>
//                     {w.createdAt?.toDate
//                       ? w.createdAt.toDate().toLocaleString()
//                       : new Date(w.createdAt).toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {lastVisible && (
//           <div className="text-center mt-3">
//             <button
//               className="btn btn-secondary"
//               onClick={() => fetchWithdrawals(true)}
//               disabled={loading}
//             >
//               Load More
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Withdrawal;
